import React, { useEffect, useState } from "react";
import "../loginModal.css";
import Dialog from "./ui/Dialog";
import { fetchJson } from "./ui/fetchJson";
import { parseRows } from "./daSignalModel";

// The months the DA signal history covers, from the file the DA Signal page reads: "Jan 2026 to Sep 2026".
// null until it is read, or when it cannot be (the item then names no months).
const useHistorySpan = (open) => {
  const [span, setSpan] = useState(null);
  useEffect(() => {
    if (!open || span) return undefined;
    let gone = false;
    fetchJson("/bi-data/daSignalData.json")
      .then((d) => {
        const rows = parseRows(d && d.history);
        if (gone || !rows.length) return;
        const first = rows[0].label;
        const last = rows[rows.length - 1].label;
        setSpan(first === last ? first : `${first} to ${last}`);
      })
      .catch(() => {});
    return () => {
      gone = true;
    };
  }, [open, span]);
  return span;
};

const Check = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1f7a4d" strokeWidth="2.4"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" className="fn-auth-check">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

const LoginModal = ({ isOpen, onClose, onLogin }) => {
  const span = useHistorySpan(isOpen);
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title="Create your free account"
      subtitle={"Save your research · Get DA signal alerts"}
      titleId="login-modal-title"
    >
      <div className="fn-auth-benefits">
        <ul>
          <li>
            <Check />
            <span className="fn-num">{span ? `DA signal history, ${span}` : "DA signal history, month by month"}</span>
          </li>
          <li>
            <Check />
            Save research across sessions
          </li>
          <li>
            <Check />
            Webinar access when available
          </li>
        </ul>
        {/* What signing in shows: the portfolio pages lock these behind sign-in (SEBI) */}
        <span className="fn-auth-muted">
          Signing in shows each portfolio's CAGR, max drawdown and trades closed more than 60 days ago {"·"} No
          card required
        </span>
      </div>

      <button type="button" className="fn-btn fn-btn-primary fn-btn-block" onClick={() => onLogin("paid")}>
        Log in
      </button>
      <button type="button" className="fn-btn fn-btn-secondary fn-btn-block" onClick={() => onLogin("freeSignup")}>
        Create free account
      </button>

      <p className="fn-dlg-note">SEBI INH000024143 {"·"} Not investment advice</p>
    </Dialog>
  );
};

export default LoginModal;
